import { useEffect, useRef, useState } from 'react'

// Returns the nearest block-level ancestor. Inline parents (e.g. custom elements like
// <buyer-intent-view>) split into anonymous boxes when containing block children, causing
// getBoundingClientRect().top to differ from the child's top even before any scrolling.
const getBlockParent = node => {
  let parent = node.parentNode
  while (parent && parent !== document.documentElement) {
    if (!window.getComputedStyle(parent).display.includes('inline')) return parent
    parent = parent.parentNode
  }
  return parent
}

const useSticky = (offset = 0) => {
  const [isSticky, setIsSticky] = useState(false)
  const ref = useRef()

  useEffect(() => {
    const checkSticky = () => {
      const parent = getBlockParent(ref.current)
      setIsSticky(parent.getBoundingClientRect().top + offset !== ref.current.getBoundingClientRect().top)
    }

    checkSticky()

    window.addEventListener('scroll', checkSticky)

    return () => window.removeEventListener('scroll', checkSticky)
  }, [offset])
  return [ref, isSticky]
}

export default useSticky
